<template>
  <div class="routes-list">
    <template v-for="(route, index) in routesList">
    <template v-if="route.name || route.title">
      <div class="route-container" :key="index">
        <div class="route-element" >
          <template v-if="route.url">
            <a :href="route.url" target="_blank">Enlace a Wikiloc</a>
          </template>
          <div class="route-title">
            {{route.title}}
          </div>
          <div class="route-name">{{route.name}}</div>
          <div class="route-distance">{{route.distance}}</div>
          </div>
      </div>
    </template>
  </template>
  </div>
</template>

<script>
export default {
  name: 'RoutesList',
  props: {
    routesList: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.routes-list {
  text-align: center;
  margin-bottom: 50px;
}

.route-container {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.route-element {
  background: white;
  border: 1px solid transparent;
  border-radius: 6px;
  min-height: 20px;
  width: 60%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 6px;
  text-align: left;
}

.route-title {
  font-size: 18px;
  font-weight: bold;
}

.route-element a {
  text-decoration: none;
  color: #e73c1d;
  font-weight: 600;
  float: right;
}

.route-name{
  font-weight: 600;
}

.route-distance {
  font-style: italic;
}

.route-title, .route-name, .route-distance {
  display: inline-block;
  margin-right: 5px;
}
</style>
